// extracted by mini-css-extract-plugin
export default {"root":"Limit__root___IroWK"};